import {
  Center,
  Loader,
  LoadingOverlay,
  Stack,
  Text,
  type LoaderProps,
  type LoadingOverlayProps,
} from "@mantine/core";
import type { ReactNode } from "react";
import { NullLoader } from "./null/NullLoader";

type Props = LoadingOverlayProps & {
  type?: LoaderProps["type"] | "logo";
  size?: LoaderProps["size"];
  text?: ReactNode;
};

export function ContentLoader({
  type = "ring",
  color = "indigo.4",
  text,
  size = 80,
  ...props
}: Props) {
  const loader = () => {
    switch (type) {
      case "logo":
        return <NullLoader animated w={size} />;
      default:
        return <Loader size={size} type={type} color={color} />;
    }
  };

  return (
    <LoadingOverlay
      {...props}
      loaderProps={{
        children: (
          <Stack gap={0}>
            <Center>{loader()}</Center>
            {text ? (
              <Center>
                <Text c="dimmed">{text}</Text>
              </Center>
            ) : null}
          </Stack>
        ),
        ...props.loaderProps,
      }}
      overlayProps={{
        color: "var(--mantine-color-body)",
        blur: 0.75,
        ...props.overlayProps,
      }}
    />
  );
}
